export default __webpack_public_path__ + "static/media/PrintLayout.bef9f2e7.svg";